<template>
  <v-container fluid>
    <v-row class="without-auth-main-bg d-block">
      <!-- DE-BRANDIFY -->
      <top-bar-without-auth :show-create-account="true" />
      <v-col cols="12" class="d-flex align-baseline justify-center mt-md-14 pt-14">
        <v-row
          :class="[
            'pa-0 align-baseline justify-center',
            $vuetify.breakpoint.mdAndUp ? ' login-signup-form-container' : '',
          ]"
        >
          <h2
            :class="[
              'outfit-bold font-700  font-700 text-light-black mb-5',
              $vuetify.breakpoint.mdAndUp ? 'text-40' : 'text-30',
            ]"
          >
            Expired Link
          </h2>
          <v-col cols="12" md="12" class="px-6 login-signup-form-outer">
            <div class="outfit text-16 text-light-black">
              For security reasons, password links expire after a certain period. We've just sent you a new link via
              email — please check your inbox. If you didn't receive it, you can request another below.
            </div>
            <v-tooltip v-if="cooldown" bottom>
              <template #activator="{ on, attrs }">
                <div class="mt-5 text-center text-14 font-700 text-grey cursor-pointer" v-bind="attrs" v-on="on">
                  Didn't Receive An Email? Click Here To Request A New Link.
                </div>
              </template>
              <span class="white--text">Please wait {{ cooldownSeconds }} seconds before requesting a new link.</span>
            </v-tooltip>

            <!-- If cooldown is false, show the same element without a tooltip -->
            <div
              v-else
              class="mt-5 text-center text-14 font-700 text-decoration-underline cursor-pointer"
              @click="resendLink"
            >
              Didn't Receive An Email? Click Here To Request A New Link.
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppFooter from "@/components/Jlpc/AppFooter.vue";
import TopBarWithoutAuth from "@/components/General/TopBarWithoutAuth.vue";

export default {
  name: "LinkExpired",

  components: {
    TopBarWithoutAuth,
    AppFooter,
  },

  data() {
    return {
      cooldown: true,
      cooldownSeconds: 60,
      intervalId: null,
    };
  },

  computed: {
    linkType() {
      return this.$route.params.linkType;
    },
    token() {
      return this.$route.query.token;
    },
    uid() {
      return this.$route.query.uid;
    },
  },

  mounted() {
    const validLinkTypes = ["invitation", "password_reset"];

    if (!validLinkTypes.includes(this.linkType)) {
      this.$router.replace({ name: "NotFound" });
      return;
    }

    this.resendLink();
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  methods: {
    async resendLink() {
      try {
        await this.$axios.post(`/client/resend`, {
          token: this.token,
          uidb64: this.uid,
          token_type: this.linkType,
        });
        this.startCooldown();
      } catch (e) {
        console.error(e);
      }
    },

    startCooldown() {
      this.cooldown = true;
      this.intervalId = setInterval(() => {
        this.cooldownSeconds--;
        if (this.cooldownSeconds <= 0) {
          this.cooldown = false;
          clearInterval(this.intervalId);
          this.cooldownSeconds = 60;
        }
      }, 1000);
    },
  },
};
</script>
